module.exports = __webpack_public_path__ + "img/img_weitongguo.46ebb34b.png";